var mixins = {
    methods: {
        navigationTo(path, query, params){
          console.log('params')
          console.log(params)
            this.$router.push({path, query, params})
        },
        back(){
            this.$router.back();
        },

    },
    directives: {
      'clickoutside':{
        bind(el, binding, vnode){
          function documentHandler(e){
            if(el.contains(e.target)){
              return false;
            }

            if(binding.expression){
              binding.value(e)
            }
          }

          el.__vueClickOutSide__ = documentHandler;
          document.addEventListener('click', documentHandler)
        },

        destory(el, binding, vnode){
          document.removeEventListener('click', el.__vueClickOutSide__);
          delete el.__vueClickOutSide__;
        }
      }
    }
}

export default mixins;



// WEBPACK FOOTER //
// ./src/mixins/index.js